// removed by extract-text-webpack-plugin
module.exports = {"promotionWrapper":"_19DqBdsgKumaSHtmvgkNqX","title":"_33DiNOrBXHECFmiM-i9tLu","description":"_3fmJavlVjsXCUIqRzWWVGP","addPromo":"_3BoroI03DZWHWmQI_y6mYI","green":"_6RxayPRSBjCOSNUqU4ZKY","pink":"_1iIOIwHQCUZxi0dl_8s8d9","orange":"_3ipkHC5dZgEyW2Qhoysy3A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorAdditionalPromotion/RealtorAdditionalPromotion.scss
// module id = 1744
// module chunks = 0